import MainLayout from "Layouts/Main";
import { useNavigate, NavLink, Outlet } from "react-router-dom";
import assets from "Assets";
import './styles.scss';

function ViewUser() {

    const navigate = useNavigate();

    const requestNavLinks = [
        {
            to: "profileDetails",
            label: "Profile Details",
            id: "1",
        },
        {
            to: "creditHistory",
            label: "Credit History",
            id: "2",
        },
        {
            to: "purchaseHistory", 
            label: "Purchase History",
            id: "3",
        },
    ];

    return (
        <MainLayout pageName={"User Management"}>
            <div className="goBackDiv" onClick={() => navigate("/userManagement")}> {/* Fixed the path */}
                <img src={assets.Icons.leftArrow} alt="backIcon" />
                <p>Back to User Management</p>
            </div>
            <div className='requestContainer'>
                <div className="requestNavBar">
                    {requestNavLinks.map((option) => (
                        <div key={option.id} className="requestOptionContainer">
                            <NavLink
                                key={option.id}
                                to={option.to}
                                style={{ textDecoration: "none" }}
                                className={({ isActive }) =>
                                    isActive ? "active-requestOptionContainerNav" : "requestOptionContainerNav"
                                }
                            >
                                {option.label}
                            </NavLink>
                        </div>
                    ))}
                </div>
                <br></br>
                <Outlet /> {/* Renders child route components */}
            </div>
        </MainLayout>
    );
}

export default ViewUser;
